import React, { ChangeEvent, useCallback, useContext, useState } from "react";
import { houseIdPrefixLabelValueSets } from "../../../../../domain/care_recipient/CareRecipientHouseId";
import { CareRecipientSortCondition } from "../../../../../domain/care_recipient/CareRecipientWithDataSyncInformation";
import { userAccountRoleList } from "../../../../../domain/user/account/UserAccountRole";
import { AdminListContext } from "../../../../provider/AdminListProvider";
import { FilterButton } from "../../FilterButton";

export const AdminListTableHead = React.memo(function AdminListTableHead() {
    const {
        setSortCondition,
        setSortAsc,
        houseIdPrefixFilters,
        setHouseIdPrefixFilters,
        userRoleFilters,
        setUserRoleFilters,
        displayList
    } = useContext(AdminListContext);

    const [filterOpen, setFilterOpen] = useState<boolean>(false);

    const [userFilterOpen, setUserFilterOpen] = useState(false);

    const onClickSortButton = useCallback((condition: CareRecipientSortCondition, asc: boolean) => () => {
        setSortCondition(condition);
        setSortAsc(asc);
    }, [setSortCondition, setSortAsc]);

    const handleFilterChanged = useCallback((e: ChangeEvent<HTMLInputElement>) => {
        const houseIdPrefix = e.target.value;
        const newHouseIdPrefixFilters = houseIdPrefixFilters.includes(houseIdPrefix) ? houseIdPrefixFilters.filter(f => f !== houseIdPrefix) : [...houseIdPrefixFilters, houseIdPrefix];
        setHouseIdPrefixFilters(newHouseIdPrefixFilters);
    }, [houseIdPrefixFilters, setHouseIdPrefixFilters]);

    const handleUserRoleFilterChanged = useCallback((e: ChangeEvent<HTMLInputElement>) => {
        const role = e.target.value;
        const newUserRoleFilters = userRoleFilters.includes(role) ? userRoleFilters.filter(f => f !== role) : [...userRoleFilters, role];
        setUserRoleFilters(newUserRoleFilters);
    }, [userRoleFilters, setUserRoleFilters]);

    const onClickCopyButton = useCallback(() => {
        const mailAddressList = displayList?.flatMap(item => (
            item.users.map(user => user.email.value)
        )).join(" ") ?? "";

        navigator.clipboard.writeText(mailAddressList).then(() => alert("メールアドレスをコピーしました。"));
    }, [displayList]);

    return (
        <thead>
            <tr>
                <td colSpan={6} className={"care_recipient_header"}>利用者</td>
                <td colSpan={4} className={"user_header"}>ユーザー</td>
            </tr>
            <tr>
                <td className={"care_recipient_header"}>
                    ハウスID
                    <FilterButton
                        filterOpen={filterOpen}
                        handleFilter={open => setFilterOpen(open)}
                        openIconPath={"/images/icon_filter.svg"}
                        filterConditions={houseIdPrefixLabelValueSets}
                        currentConditions={houseIdPrefixFilters}
                        handleFilterChanged={handleFilterChanged}
                    />
                </td>
                <td className={"care_recipient_header"}>氏名</td>
                <td className={"care_recipient_header"}>生年月日</td>
                <td className={"care_recipient_header"}>システム利用開始日</td>
                <td className={"care_recipient_header"}>システム利用終了日</td>
                <td className={"care_recipient_header"} />
                <td className={"user_header"} rowSpan={2}>ユーザー名</td>
                <td className={"user_header"} rowSpan={2}>
                    メールアドレス
                    <button className={"icon_button"} onClick={onClickCopyButton}>
                        <img src={"/images/icon_copy.svg"} alt="COPY" title="COPY" />
                    </button>
                </td>
                <td className={"user_header"} rowSpan={2}>
                    続柄
                    <FilterButton
                        filterOpen={userFilterOpen}
                        handleFilter={open => setUserFilterOpen(open)}
                        openIconPath={"/images/icon_filter.svg"}
                        filterConditions={userAccountRoleList}
                        currentConditions={userRoleFilters}
                        handleFilterChanged={handleUserRoleFilterChanged}
                    />
                </td>
                <td className={"user_header"} rowSpan={2} />
            </tr>
            <tr>
                <td className={"care_recipient_header"}>
                    <div className={"sort_button_area"}>
                        <button className={"sort_button"} type="button" onClick={onClickSortButton(CareRecipientSortCondition.HOUSE_ID, true)}>▲</button>
                        <button className={"sort_button"} type="button" onClick={onClickSortButton(CareRecipientSortCondition.HOUSE_ID, false)}>▼</button>
                    </div>
                </td>
                <td className={"care_recipient_header"}>
                    <div className={"sort_button_area"}>
                        <button className={"sort_button"} type="button" onClick={onClickSortButton(CareRecipientSortCondition.CARE_RECIPIENT_NAME, true)}>▲</button>
                        <button className={"sort_button"} type="button" onClick={onClickSortButton(CareRecipientSortCondition.CARE_RECIPIENT_NAME, false)}>▼</button>
                    </div>
                </td>
                <td className={"care_recipient_header"}></td>
                <td className={"care_recipient_header"}>
                    <div className={"sort_button_area"}>
                        <button className={"sort_button"} type="button" onClick={onClickSortButton(CareRecipientSortCondition.DATA_SYNC_START_TIME, true)}>▲</button>
                        <button className={"sort_button"} type="button" onClick={onClickSortButton(CareRecipientSortCondition.DATA_SYNC_START_TIME, false)}>▼</button>
                    </div>
                </td>
                <td className={"care_recipient_header"}></td>
                <td className={"care_recipient_header"}></td>
            </tr>
        </thead>
    );
});
